<template>
  <li
    class="cart-product-card"
    :class="{ 'cart-product-card--several-goods': severalGoods, 'cart-product-card--gift': isGift }"
    :data-productKey="product.code"
  >
    <button
      v-if="!checkout && !notAvailablePopup && isAllowCartManagement && !severalGoods && !isGift"
      class="cart-product-card__remove-btn"
      :class="{ 'cart-product-card__remove-btn--several-goods': product.items && product.items.length }"
      v-on="{ click: isInWishList ? removeFromCart : toggleApproveRemove }"
      :title="$t('cart_remove')"
    >
      <svg width="18"
           height="18"
           viewBox="0 0 18 18"
           fill="none"
           xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12.75 16.5H5.25C4.42157 16.5 3.75 15.8284 3.75 15V5.25H2.25V3.75H5.25V3C5.25 2.17157 5.92157 1.5 6.75 1.5H11.25C12.0784 1.5 12.75 2.17157 12.75 3V3.75H15.75V5.25H14.25V15C14.25 15.8284 13.5784 16.5 12.75 16.5ZM5.25 5.25V15H12.75V5.25H5.25ZM6.75 3V3.75H11.25V3H6.75ZM11.25 13.5H9.75V6.75H11.25V13.5ZM8.25 13.5H6.75V6.75H8.25V13.5Z"
          fill="#909090"
        />
      </svg>
    </button>
    <div
      v-if="approveRemove"
      v-click-outside="hideApproveRemove"
      class="cart-product-card__approve-remove approve-remove"
    >
      <button @click.prevent="addToWishList" class="approve-remove__btn approve-remove__btn--wish-list">
        {{ $t('cart_to_wish_list') }}
      </button>
      <button @click.prevent="removeFromCart" class="approve-remove__btn approve-remove__btn--remove">
        {{ $t('cart_remove') }}
      </button>
      <button @click.prevent="hideApproveRemove" class="approve-remove__btn approve-remove__btn--cancel">
        {{ $t('cart_cancel') }}
      </button>
    </div>
    <a :href="product.productUrl"
    ><img
      class="cart-product-card__img"
      :class="{ 'cart-product-card__img--checkout': checkout, 'cart-product-card__img--gift': isGift }"
      :src="product.imageUrl"
      :alt="product.name"
    /></a>
    <div class="cart-product-card__title-wrapper" :class="{ 'cart-product-card__title-wrapper--gift': isGift }">
      <a
        :href="product.productUrl"
        class="link cart-product-card__title"
        :class="{
          'cart-product-card__title--checkout': checkout,
          'cart-product-card__title--not-available-popup': notAvailablePopup
        }"
      >{{ product.name }}</a
      >
      <BuyBtn
        v-if="isClientCart"
        :product-id="product.id"
        :code="product.code"
        :price="product.price"
        :btn-text="$t('add_to_cart')"
        class="cart-product-card__add-to-cart"
      />
      <span
        v-if="isCheckoutStatusShown"
        class="product-info__status"
        :class="{
          'product-info__status--in-stock': product.status === 1,
          'product-info__status--will-be-in-stock': product.status === 2,
          'product-info__status--not-in-stock': product.status === 0
        }"
      >
        {{
          product.status === 0
            ? $t('reserve_order_not_available')
            : product.status === 1
              ? $t('reserve_now_in_stock')
              : product.status === 2
                ? $t('reserve_will_be_in_stock')
                : ''
        }}
      </span>
    </div>
    <div
      class="cart-card-blocks"
      v-if="!isGift"
      :class="{
        'cart-card-blocks--checkout': checkout,
        'cart-card-blocks--top-offset': isCheckoutStatusShown || isClientCart,
        'cart-card-blocks--not-available-popup': notAvailablePopup
      }"
    >
      <div class="cart-card-start-block">
        <span class="cart-card-price-block__price--old"
              v-if="product.price_old && product.price_old > product.price && !checkout"
        >{{ product.price_old | currencyFormatter }} {{ product.currency }}</span
        >
        <span v-if="product.price"
              class="cart-card-price-block__price"
        >{{ product.price | currencyFormatter }} {{ product.currency }}</span
        >
      </div>
      <div class="cart-card-middle-block" v-if="checkout || severalGoods">
        <span>{{ product.itemQuantity }} шт.</span>
      </div>
      <div class="cart-card-middle-block" v-else-if="!notAvailablePopup && product.maxQuantity">
        <button
          class="quantity-changer__btn quantity-changer__btn--decrement"
          :disabled="itemQuantity <= 1"
          @click.prevent="decrementQuantity"
          :title="$t('cart_product_decrement')"
        >
          <svg width="16"
               height="2"
               viewBox="0 0 16 2"
               xmlns="http://www.w3.org/2000/svg">
            <rect width="16" height="1.5" />
          </svg>
        </button>
        <input v-model.number.trim="itemQuantity"
               class="quantity-changer__input"
               type="number"
               min="1" />
        <button
          class="quantity-changer__btn quantity-changer__btn--increment"
          :disabled="itemQuantity >= product.maxQuantity"
          @click.prevent="incrementQuantity"
          :title="$t('cart_product_increment')"
        >
          <svg width="16"
               height="16"
               viewBox="0 0 16 16"
               xmlns="http://www.w3.org/2000/svg">
            <rect y="7.27271" width="16" height="1.45455" />
            <rect x="7.27246"
                  y="16"
                  width="16"
                  height="1.45455"
                  transform="rotate(-90 7.27246 16)" />
          </svg>
        </button>
      </div>
      <div
        class="cart-card-end-block"
        v-if="!notAvailablePopup && !severalGoods && product.itemQuantity && product.price"
      >
        <span
          :class="{
            'cart-card-price-block__total-price': checkout,
            'cart-card-price-block__total-price--cart-modal': cartModal
          }"
        >
          {{ (product.price * product.itemQuantity) | currencyFormatter }} {{ product.currency }}
        </span>
      </div>
      <slot></slot>
    </div>
    <ul v-if="product.type === 'gift_set' && product.items" class="cart-product-card__several-goods">
      <li class="cart-product-card__gift-title">{{ $t('gift_title') }}</li>
      <product-card
        is-gift
        v-for="(itemProduct, i) in product.items"
        :product="itemProduct"
        :checkout="checkout"
        :key="i"
      />
    </ul>
    <ul v-else-if="product.items" class="cart-product-card__several-goods">
      <product-card
        several-goods
        v-for="(itemProduct, i) in product.items"
        :product="itemProduct"
        :checkout="checkout"
        :key="i"
      />
    </ul>
    <loader :is-loading="isLoading"></loader>
  </li>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex'
import CurrencyFormatter from '../../filters/CurrencyFormatter'
import vClickOutside from 'v-click-outside'
import Loader from '../helpers/Loader'
import BuyBtn from '../cart/BuyBtn'
import { debounce } from '../../mixins'
import { GoogleEnhancedEcommerce, GoogleTagManagerService } from '@/services/AnalyticService'

export default {
  name: 'ProductCard',
  data: function () {
    return {
      approveRemove: false,
      isLoading: false,
      itemQuantity: this.product.itemQuantity,
      isWishlistLoading: false
    }
  },
  mixins: [debounce],
  components: { Loader, BuyBtn },
  props: {
    product: {
      productUrl: String,
      quantityUrl: String,
      removeUrl: String,
      imageUrl: String,
      name: String,
      price: Number,
      price_old: Number,
      currency: String,
      itemQuantity: Number,
      maxQuantity: Number,
      id: Number,
      hashId: Number,
      code: String,
      items: Array,
      isInWishlist: Boolean,
      arrivalDate: String,
      isAvailable: Boolean
    },
    checkout: Boolean,
    isReserve: Boolean,
    notAvailablePopup: Boolean,
    cartModal: Boolean,
    severalGoods: Boolean,
    isClientCart: Boolean,
    isGift: Boolean,
    isAllowCartManagement: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapGetters(['urlLanguagePrefix']),
    ...mapGetters('wishlist', ['productsIdsInWishlist']),
    ...mapState({
      user: state => state.user,
      formData: state => state.checkout.formData
    }),
    storeUidForCheckout () {
      return this.formData?.deliveryType?.methodId === 1 &&
      this.formData?.deliveryInfo?.deliverySpot?.uid
        ? this.formData.deliveryInfo.deliverySpot.uid
        : null
    },
    isDeliveryType () {
      return (
        this.formData?.deliveryType?.methodId === 1 &&
        this.formData?.deliveryInfo?.deliverySpot
      )
    },
    isCheckoutStatusShown () {
      return (this.product.status || this.product.status === 0) && this.checkout && this.isDeliveryType
    },
    isInWishList () {
      return this.productsIdsInWishlist.length ? this.productsIdsInWishlist.includes(this.product.id) : false
    },
    analyticsData () {
      return this.product['analytics_data'].map(item => {
        item.quantity *= this.product.itemQuantity
        return item
      })
    }
  },
  methods: {
    ...mapActions('wishlist', ['CHANGE_WISH_LIST_STATUS']),
    addToWishList () {
      if (this.user && this.user.auth) {
        this.isWishlistLoading = true

        this.CHANGE_WISH_LIST_STATUS({ id: this.product.id })
          .then(() => {
            if (GoogleEnhancedEcommerce.isEnabled) {
              GoogleEnhancedEcommerce.addToWishlist({
                universal_value: this.isInWishList ? 'add' : 'removed',
                value: +GoogleEnhancedEcommerce.getGoogleEnhancedEcommerceData(this.analyticsData[0]).price * parseInt(GoogleEnhancedEcommerce.getGoogleEnhancedEcommerceData(this.analyticsData[0]).quantity || 1),
                items: [GoogleEnhancedEcommerce.getGoogleEnhancedEcommerceData(this.analyticsData[0])]
              })
            }
            this.removeFromCart()
          })
          .catch(error => this.notifyError(error))
          // eslint-disable-next-line no-return-assign
          .finally(() => (this.isWishlistLoading = false))
      } else {
        window.addEventListener('wishListTrigger', () => {
          this.addToWishList()
        })

        this.$modal.show('auth-modal', {
          title: this.$t('wishlist.auth'),
          isAjaxAuth: true,
          referrer: 'wish-list'
        })
      }
    },
    removeFromCart () {
      this.isLoading = true
      this.$store
        .dispatch('REMOVE_PRODUCT_FROM_CART', {
          ...this.product,
          storeUid: this.storeUidForCheckout,
          deliveryType: this.formData.deliveryType ? this.formData.deliveryType.methodId : null
        })
        .then(() => {
          GoogleTagManagerService.removeFromCartEvent({
            analyticsData: this.analyticsData,
            params: {
              'event': 'gtm-ee-event-remove-from-cart',
              'gtm-ee-event-action': 'Removing a Product from a Shopping Cart'
            }
          })

          this.isLoading = false
          this.$store.dispatch('CHANGE_CART_RTB_HOUSE_CODE_FLAG', true)
        })
        .catch(error => {
          this.isLoading = false
          this.notifyError(error)
        })
    },
    incrementQuantity () {
      this.itemQuantity++
    },
    decrementQuantity () {
      this.itemQuantity--
    },
    changeQuantity () {
      if (!this.isAllowCartManagement) {
        this.$emit('changeQuantity', this.itemQuantity)
      } else {
        if (this.isLoading || this.modificator) return
        this.isLoading = true
        this.$store
          .dispatch('CHANGE_PRODUCT_QUANTITY', {
            productHashId: this.product.hashId,
            productQuantity: this.itemQuantity,
            storeUid: this.storeUidForCheckout,
            deliveryType: this.formData.deliveryType ? this.formData.deliveryType.methodId : null
          })
          .then(() => {
            this.isLoading = false
            this.$store.dispatch('CHANGE_CART_RTB_HOUSE_CODE_FLAG', true)
          })
          .catch(error => {
            this.isLoading = false
            this.notifyError(error)
          })
      }
    },
    toggleApproveRemove () {
      this.approveRemove = true
    },
    hideApproveRemove () {
      this.approveRemove = false
    },
    notifyError (message) {
      this.$notify({
        group: 'error',
        title: this.$t('error'),
        text: message,
        type: 'error'
      })
    }
  },
  watch: {
    itemQuantity: function () {
      if (this.itemQuantity >= this.product.maxQuantity) {
        this.itemQuantity = this.product.maxQuantity
      } else if (this.itemQuantity <= 0) {
        this.itemQuantity = 1
      }
      this.itemQuantity = Math.round(this.itemQuantity)
      this.debounce(() => this.changeQuantity(), 300)
    }
    // product: function () {
    //   this.itemQuantity = this.product.itemQuantity
    // }
  },
  filters: { CurrencyFormatter },
  directives: {
    clickOutside: vClickOutside.directive
  }
}
</script>

<style scoped lang="sass">

.cart-product-card
  display: flex
  flex-wrap: wrap
  padding: 15px 0 20px
  border-bottom: 1px solid #e1e1e1
  position: relative

  +mmin(768)
    padding: 20px 0

  &--several-goods, &--gift
    border-bottom: 0
    padding: 0
    border-left: 1px solid #e1e1e1

  &--several-goods
    width: 60%

  &--gift
    padding-left: 20px
    padding-bottom: 20px

    +mmin(768)
      padding-bottom: 10px

.cart-product-card__img
  display: block
  font-size: 8px
  width: 60px
  height: 60px
  object-fit: contain
  margin-right: 13px

  +mmin(768)
    &:not(&--checkout)
      width: 100px
      height: 100px
      margin-right: 20px

.cart-product-card__img.cart-product-card__img--gift
  width: 50px

.cart-product-card__info-wrapper
  display: flex
  flex-direction: column
  justify-content: center

.cart-card-blocks
  display: flex
  justify-content: space-between
  width: 100%
  margin: 15px 0 0

  +mmin(768)
    &:not(&--checkout)
      width: calc(100% - 120px)
      margin: -45px 0 0 120px

  & > div
    display: flex
    align-items: center

  &--checkout
    margin-top: -15px
    margin-left: 75px
    width: 100%

    .cart-card-end-block
      width: auto

    .cart-card-middle-block
      margin-left: 0

  &--top-offset
    margin-top: 20px

  &--not-available-popup
    width: 100%

.cart-product-card__title-wrapper
  width: calc(100% - 120px)

  +mmin(768)
    width: calc(100% - 140px)

  &--gift
    display: flex
    align-items: center

    .cart-product-card__title
      margin-top: 0

.cart-product-card__title
  font-size: 14px
  margin-top: 10px

  +mmin(768)
    font-size: 15px

  &--checkout, &--not-available-popup
    margin-top: 0
    max-height: 40px
    overflow: hidden
    display: -webkit-box
    -webkit-line-clamp: 2
    -webkit-box-orient: vertical

  &--not-available-popup
    +mmin(768)
      width: calc((100% - 120px) / 2)

.quantity-changer__btn
  width: 16px
  height: 16px
  padding: 0
  margin: 0 20px
  border: 0
  background: none
  line-height: 0

  &:disabled
    fill: $placeholder-color

.quantity-changer__input
  line-height: 40px
  width: 40px
  border: 1px solid $nd-border-color
  border-radius: 3px
  text-align: center
  -moz-appearance: textfield
  &:focus
    border: 1px solid $nd-focus-border-color

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button
    -webkit-appearance: none
    margin: 0

.cart-card-middle-block
  +mmin(768)
    margin-left: auto

.cart-card-end-block
  width: 110px
  justify-content: flex-end

  +mmin(768)
    margin-left: 50px

.product-info__status
  font-size: 14px
  margin-top: 10px
  display: block

  &--not-in-stock
    color: $placeholder-color

  &--in-stock
    color: $nd-green-text-color

  &--will-be-in-stock
    color: $main-color

.cart-product-card__remove-btn
  position: absolute
  width: 20px
  height: 20px
  padding: 0
  border: 0
  background: none
  top: 50%
  left: -18px
  transform: translate(-100%, -50%)
  opacity: .5

  &--several-goods
    top: 60px
    left: -35px

    +mmin(768)
      transform: none

  +mmax(768)
    top: 25px
    left: 100%

  &:hover
    opacity: 1

.approve-remove
  background-color: #ffffff
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.15)
  border-radius: 3px
  position: absolute
  padding: 5px 10px
  display: flex
  flex-flow: row wrap
  max-width: 211px

  +mmax(768)
    left: auto
    right: 0

    &:before
      content: ''

.approve-remove__btn
  width: calc(50% - 15px)
  background-color: transparent
  border: 0
  font-weight: 400
  font-size: 12px
  line-height: 14px
  text-align: center
  padding: 9px 8px
  text-decoration: underline dotted

  &:hover, &:focus
    text-decoration: none

.approve-remove__btn--wish-list, .approve-remove__btn--remove
  position: relative
  padding-top: 42px

  &:before
    content: ''
    width: 26px
    height: 23px
    position: absolute
    top: 9px
    left: 50%
    transform: translateX(-50%)
    background-size: contain
    background-repeat: no-repeat
    background-position: 50%

.approve-remove__btn--wish-list
  margin-right: 15px

  &:before
    background-image: url(/img/svgo/cart/wish-list.svg)

  &:after
    content: ''
    position: absolute
    width: 1px
    height: 60px
    background: #E7E7E7
    top: 10px
    right: -15px

.approve-remove__btn--remove
  margin-left: 15px

  &:before
    background-image: url(/img/svgo/cart/remove.svg)

.approve-remove__btn--cancel
  width: 100%

.cart-card-start-block
  flex-direction: column
  justify-content: center
  width: 110px

  & > span
    align-self: baseline

.cart-card-price-block__price
  &--old
    color: $placeholder-color
    text-decoration-line: line-through

.cart-card-price-block__total-price
  font-weight: 500

.cart-card-price-block__total-price--cart-modal
  font-size: 16px

.cart-product-card__several-goods
  margin-top: 20px
  padding-left: 0

.cart-product-card__gift-title
  list-style: none
  margin-bottom: 15px
  color: $placeholder-color

.cart-product-card__add-to-cart
  margin: 5px 0
</style>
